import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store'
import TypeIt from 'typeit'
import VueProgressBar from 'vue-progressbar'
import NavbarPage from '@/components/template/navbar.vue'
import FooterPage from '@/components/template/footer.vue'
import HeroSection from '@/components/sections/heroSection.vue'
import MediumHomeSection from '@/components/sections/sectionMediumHome.vue'
import SmallHomeSection from '@/components/sections/sectionSmallHome.vue'
import MediumHomeSectionTwo from '@/components/sections/sectionMediumHomeTwo.vue'
import MediumHomeSectionThree from '@/components/sections/sectionMediumHomeThree.vue'
import SmallHomeSectionTwo from '@/components/sections/sectionSmallHomeTwo.vue'
import SmallSectionPortfolio from '@/components/sections/sectionSmallPortfolio.vue'
import WhiteSectionPortfolio from '@/components/sections/portfolio/whiteSectionPortfolio.vue'
import BlueSectionPortfolio from '@/components/sections/portfolio/blueSectionPortolio.vue'

// Require the main Sass manifest file
require('./assets/sass/main.scss')

Vue.config.productionTip = false

Vue.use(VueProgressBar)

Vue.component('navbar-page', NavbarPage)
Vue.component('footer-page', FooterPage)
Vue.component('hero-section', HeroSection)
Vue.component('medium-home-section', MediumHomeSection)
Vue.component('small-home-section', SmallHomeSection)
Vue.component('small-home-section-two', SmallHomeSectionTwo)
Vue.component('medium-home-section-two', MediumHomeSectionTwo)
Vue.component('medium-home-section-three', MediumHomeSectionThree)
Vue.component('white-section-portfolio', WhiteSectionPortfolio)
Vue.component('small-section-portfolio', SmallSectionPortfolio)
Vue.component('blue-section-portfolio', BlueSectionPortfolio)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

new TypeIt('#hero', {
  speed: 75,
  startDelay: 100
})

new TypeIt('#hero-sub', {
  speed: 75,
  cursor: false,
  startDelay: 3000
})
